import { FC } from 'react'
import { useLocation } from 'react-router-dom'

import { TextPromo } from 'components/ui'
import { Space } from 'components/ui/Space/Space'
import { useResize } from 'utils/hooks/useResize'
import { PromoRoutesEnum } from 'shared/constants/routes'
import { SCROLL_TO_ID } from 'shared/constants/values'

import { PickPointBox } from './components/PickPointBox/PickPointBox'
import { brandPPData, villagePPData } from './data'
import { pickpointType } from './types'

import s from './KindsOfPickPoints.module.scss'

export const KindsOfPickPoints: FC = () => {
  const { isDesktop, isTablet, isMobile } = useResize()
  const location = useLocation()

  const pickPoints = [
    {
      data: brandPPData,
      title: 'Стандартные',
      key: 'brand',
      type: pickpointType.standard,
      order: location.pathname === PromoRoutesEnum.simplifiedConditions ? 2 : 1,
    },
    {
      data: villagePPData,
      title: 'Упрощённые',
      key: 'village',
      type: pickpointType.simplified,
      order: location.pathname === PromoRoutesEnum.simplifiedConditions ? 1 : 2,
    },
  ].sort((a, b) => a.order - b.order)

  return (
    <section className={s.section}>
      <div id={SCROLL_TO_ID.pickPointKinds} />
      <div className={`contentWrapper ${s.pickPointKinds}`}>
        <div className={s.title}>
          <Space size={!isTablet ? 140 : 80} />
          <TextPromo center weight="w700" size={isMobile ? 's32' : isTablet ? 's40' : isDesktop ? 's70' : 's70'}>
            Условия открытия
          </TextPromo>
        </div>
        <Space size={isTablet ? (isMobile ? 24 : 40) : 64} />
        <div className={s.correlationTable}>
          {pickPoints.map(({ data, title, key, type }) => (
            <PickPointBox data={data} title={title} key={key} typeOfPickpoint={type} />
          ))}
        </div>
      </div>
    </section>
  )
}
